import { render, staticRenderFns } from "./AddressManager.vue?vue&type=template&id=64c92381&scoped=true"
import script from "./AddressManager.vue?vue&type=script&lang=js"
export * from "./AddressManager.vue?vue&type=script&lang=js"
import style0 from "./AddressManager.vue?vue&type=style&index=0&id=64c92381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c92381",
  null
  
)

export default component.exports